<template>
  <div class="productionProfitReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">鱼均费用报表</div>
        <div class="select-container">
          <div class="select-container-box tab">
            <el-select
              v-model="memoryValue"
              size="small"
              placeholder="请选择"
              @change="changeBatDateList"
            >
              <el-option
                v-for="item in batDateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'date'">
            <!-- <span>日期</span> -->
            <el-date-picker
              size="small"
              :clearable="false"
              v-model="queryParams.StartDate"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(0)"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
            <span>至</span>
            <el-date-picker
              size="small"
              :clearable="false"
              v-model="queryParams.EndDate"
              type="date"
              placeholder="结束日期"
              @change="changeTime(1)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'Batch'">
            <!-- <span>周期&nbsp;&nbsp;</span> -->
            <el-select
              v-model="queryParams.batch"
              size="small"
              placeholder="请选择"
              @change="batchChange"
            >
              <el-option
                v-for="item in batchList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>基地</span>
            <el-select
              filterable
              placeholder="请选择"
              size="small"
              v-model="queryParams.BaseId"
              @change="baseChange"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
          <div class="select-container-box">
            <span>塘口</span>
            <el-select
              filterable
              placeholder="请选择"
              size="small"
              v-model="queryParams.PondId"
            >
              <el-option
                v-for="(item, index) in pondList"
                :key="index"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
          <div class="select-container-box total">
            <span>汇总方式</span>
            <el-select
              :value="queryParams.GroupBy.split(',')"
              multiple
              size="middle"
              placeholder="请选择"
              @change="handleGroupBy"
            >
              <el-option label="塘口" value="2" />
              <el-option label="负责人" value="4" />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button
              size="small"
              type="info"
              plain
              class="query"
              @click="search(1)"
              >查询</el-button
            >
          </div>
          <!-- <ExportExcelBtn
            apiUrl="/api/ProductionReport/ExportProductionProfitReport"
            :queryParamsObj="searchQueryParams"
            fileName="生产利润表.xls"
          /> -->
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="tableData"
          style="width: 100%"
          :span-method="objectSpanMethod"
          height="100%"
          class="main-table"
          :row-class-name="tableRowClassName"
          ref="tableRef"
        >
          <el-table-column
            prop="leaderName"
            label="负责人"
            align="center"
            v-if="tableData.length && tableData[0].leaderName"
          ></el-table-column>
          <el-table-column
            prop="pondName"
            label="塘号"
            align="center"
            v-if="tableData.length && tableData[0].pondName"
          ></el-table-column>
          <el-table-column
            prop="pondArea"
            label="面积(亩)"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="fishName"
            label="品种"
            align="center"
          ></el-table-column>
          <el-table-column label="营业支出" align="center">
            <el-table-column
              prop="purchaseSpec"
              label="放养规格(斤/尾)"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="purchaseQuantity"
              label="放养尾数(尾)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="purchaseWeight"
              label="放养重量(斤)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="purchaseDensity"
              label="放养密度(尾/亩)"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="purchaseAmount"
              label="放养金额(元)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="purchaseAveragePrice"
              label="放养均价(元)"
              align="center"
            ></el-table-column>
            <el-table-column label="饲料用量(吨)" align="center">
              <template slot-scope="scope">{{
                (scope.row.fodderWeight && scope.row.fodderWeight.toFixed(2)) ||
                ""
              }}</template>
            </el-table-column>
            <el-table-column label="用料金额(元)" align="center" width="108">
              <template slot-scope="scope">{{
                (scope.row.fodderAmount && scope.row.fodderAmount.toFixed(2)) ||
                0
              }}</template>
            </el-table-column>
            <el-table-column label="鱼肥费用(元)" align="center">
              <template slot-scope="scope">{{
                (scope.row.fishGuanoAmount &&
                  Number(scope.row.fishGuanoAmount).toFixed(2)) ||
                0
              }}</template>
            </el-table-column>
            <el-table-column label="鱼药费用(元)" align="center">
              <template slot-scope="scope">{{
                (scope.row.fishMedicineAmount &&
                  scope.row.fishMedicineAmount.toFixed(2)) ||
                0
              }}</template>
            </el-table-column>
            <!-- 动态区域 Start -->
            <template v-if="tableData.length">
              <template v-for="(column, index) in tableData[0].costList">
                <el-table-column :label="column.costTypeName" align="center">
                  <template #default="scope">
                    {{
                      tableData.find(
                        (item) =>
                          item.pondId === scope.row.pondId &&
                          item.itemDataType === scope.row.itemDataType
                      ).costList[index].amount
                    }}

                    <!-- {{ JSON.stringify(tableData.find(item => item.pondId === scope.row.pondId)[index]) }} -->
                    <!-- {{ JSON.stringify(tableData.find(item => item.pondId === scope.row.pondId)[index]) }} -->
                    <!-- {{ scope.row.pondId }} -->
                    <!-- {{ index }} -->
                  </template>
                </el-table-column>
              </template>
            </template>
            <!-- 动态区域 End -->
            <el-table-column
              prop="expendTotalAmount"
              label="合计金额(元)"
              align="center"
              width="108"
            ></el-table-column>
          </el-table-column>
          <el-table-column label="营业收入" align="center">
            <el-table-column
              prop="saleWeight"
              label="起捕重量(斤)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="saleSpec"
              label="起捕规格(斤/尾)"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="saleQuantity"
              label="起捕尾数(尾)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="survivingRate"
              label="成活率"
              align="center"
              width="50"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.survivingRate + '%'"
                  placement="top"
                >
                  <span
                    v-if="
                      scope.row.itemDataType && scope.row.itemDataType === 4
                    "
                  ></span>
                  <span v-else>{{
                    Math.round(scope.row.survivingRate || 0) + "%"
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="salePrice"
              label="实际出鱼均价(元)"
              align="center"
              width="95"
            ></el-table-column>
            <el-table-column
              prop="saleAmount"
              label="销售收入(元)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="areaAvg"
              label="亩平(斤/亩)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="materialRatio"
              label="料比(斤)"
              align="center"
            ></el-table-column>
          </el-table-column>
          <el-table-column
            prop="profitTotalAmount"
            label="利润合计(元)"
            align="center"
            width="90"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import ExportExcelBtn from "../common/ExportExcelBtn";
import {
  resolveFishBaseKeyFromList,
  fishBaseIdForQuery,
} from "@/common/resolveFishBaseSelection.js";
function findLastIndex(array, callback) {
  for (var i = array.length - 1; i >= 0; i--) {
    if (callback(array[i], i, array)) {
      return i;
    }
  }
  return -1;
}
export default {
  name: "productionProfitReport",
  components: { ExportExcelBtn },
  data() {
    return {
      memoryValue: "date",
      batDateList: [
        {
          value: "Batch",
          label: "周期",
        },
        {
          value: "date",
          label: "时间",
        },
      ],
      batchList: [],
      queryParams: {
        StartDate: "", // 开始时间
        EndDate: "", // 结束时间
        batch: "",
        BaseId: "", // 基地Id
        PondId: "", // 塘口Id
        GroupBy: "2", // 汇总方式 塘口=2 负责人=4 (至少选一)
      },
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      baseList: [],
      pondList: [],
      tableData: [],
      twoWays: true, // 用于合并单元格时做判断
    };
  },
  mounted() {
    this.pageInit();
  },
  methods: {
    ...mapActions(modules.report, ["GetProductionProfitReport"]), // 查询
    ...mapActions(modules.base, ["getAllBaseList"]), // 基地
    ...mapActions(modules.pond, ["getFishPond"]), // 塘口
    ...mapActions(modules.cultureCycle, {
      getBatchList: "getBatchList", //周期下拉
    }),
    // 初始化
    async pageInit() {
      this.getTime();
      await this.getBaseList();
      this.judgeChoose();
      this.getBatch();
      this.search();
    },
    // 查询
    async search() {
      const res = await this.GetProductionProfitReport(this.searchQueryParams);
      if (res.length === 0) return (this.tableData = res);
      this.twoWays = this.queryParams.GroupBy.split(",").length === 2;
      // 过滤掉没数据的动态列 Start
      let nameArr = []; // 存放为零的 costTypeName 数组
      res[0] &&
        res[0].costList.forEach((item, index) => {
          let flag = res.every((item) => {
            if (item.itemDataType === 2) return true;
            if (item.itemDataType === 4) {
              Object.keys(item).forEach((key) => {
                if (item[key] === 0) {
                  item[key] = "";
                }
              });
            }
            return item.costList[index].amount === 0;
          });
          if (flag) nameArr.push(item.costTypeName);
        });
      // 根据nameArr数组，过滤每行costList
      res[0] &&
        res.forEach((item) => {
          item.costList = item.costList.filter(
            (item) => !nameArr.includes(item.costTypeName)
          );
        });
      // 过滤掉没数据的动态列 End
      res[0] &&
        res.forEach((item) => {
          item.costList.forEach((item) => {
            item.amount = item.amount.toFixed(2);
          });
        });
      res.forEach((item) => {
        // 放养均价计算
        item.purchaseAveragePrice =
          item.purchaseWeight === 0
            ? 0
            : (item.purchaseAmount / item.purchaseWeight).toFixed(2);

        if (item.itemDataType === 2) {
          item.leaderName = item.leaderName && "小计";
          item.pondName = item.pondName && "小计";
          item.fodderWeight = "";
        }

        // 鱼均费用特殊处理
        if (item.itemDataType === 4) {
          item.leaderName = item.leaderName && "鱼均费用";
          item.pondName = item.pondName && "鱼均费用";
          item.purchaseAveragePrice = "";
        }
      });
      // 处理合计行文字 s
      res[res.length - 2].pondName = "合计";
      res[res.length - 2].leaderName = "合计";
      if (!this.twoWays && this.queryParams.GroupBy.includes("2")) {
        res[res.length - 2].leaderName = "";
      }
      if (!this.twoWays && this.queryParams.GroupBy.includes("4")) {
        res[res.length - 2].pondName = "";
      }
      // 处理合计行文字 s
      res[res.length - 1].pondName = "鱼均费用";
      res[res.length - 1].leaderName = "鱼均费用";
      if (!this.twoWays && this.queryParams.GroupBy.includes("2")) {
        res[res.length - 1].leaderName = "";
      }
      if (!this.twoWays && this.queryParams.GroupBy.includes("4")) {
        res[res.length - 1].pondName = "";
      }
      // 处理合计行文字 e
      this.tableData = res;
    },
    // 切换基地回调函数
    async baseChange(baseId) {
      const pondList = await this.getFishPond(baseId);
      this.pondList = [{ key: "", value: "全部" }, ...pondList];
    },
    async getBaseList() {
      this.baseList = await this.getAllBaseList(); //基地
      this.queryParams.BaseId = resolveFishBaseKeyFromList(
        this.baseList,
        storage.get("base")
      );
      if (this.queryParams.BaseId != null) {
        this.baseChange(this.queryParams.BaseId);
      }
    },
    handleGroupBy(val) {
      console.log(val, 233);
      if (val.length <= 0) return this.$message.warning("必须选中一项");
      //if(val.indexOf('2') < 0) return this.$message.warning("塘口必须选中");
      this.queryParams.GroupBy = val.join();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let mergeColumnIndexList;
      let costListLength = this.tableData[0].costList.length;
      if (this.twoWays) {
        mergeColumnIndexList = [0, 1, 2, 10, 11, 12, 13];
      } else {
        mergeColumnIndexList = [0, 1, 9, 10, 11, 12];
      }
      for (let i = 0; i <= costListLength; i++) {
        mergeColumnIndexList.push(
          mergeColumnIndexList[mergeColumnIndexList.length - 1] + 1
        ); // 对动态列合并的处理
      }
      mergeColumnIndexList.push(
        mergeColumnIndexList[mergeColumnIndexList.length - 1] + 8
      ); // 对最后倒数第二列列合并的处理
      mergeColumnIndexList.push(
        mergeColumnIndexList[mergeColumnIndexList.length - 1] + 1
      ); // 对最后一列合并的处理
      // 对需要合并的列进行处理
      if (
        mergeColumnIndexList.includes(columnIndex) &&
        row.itemDataType === 1
      ) {
        // 第零行或者当前行itemDataType不等于上一行itemDataType时开始处理合并
        if (
          rowIndex === 0 ||
          row.itemDataType !== this.tableData[rowIndex - 1].itemDataType
        ) {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].itemDataType === row.itemDataType) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
      // 对小计行处理
      let startColumnLength = this.twoWays ? 4 : 3;
      if (row.itemDataType === 2) {
        // 对前3或4列处理
        if (columnIndex < startColumnLength) {
          if (columnIndex === 0) {
            if (row.leaderName && row.pondName) {
              return { rowspan: 1, colspan: 4 };
            } else {
              return { rowspan: 1, colspan: 3 };
            }
          } else {
            return { rowspan: 0, colspan: 0 };
          }
        }
        // 对动态列和部分
        if (
          startColumnLength + 7 <= columnIndex &&
          columnIndex < startColumnLength + 10 + costListLength
        ) {
          if (columnIndex === startColumnLength + 7) {
            return { rowspan: 1, colspan: 3 + costListLength };
          } else {
            return { rowspan: 0, colspan: 0 };
          }
        }
      }

      //对鱼均费用进行处理
      if (row.itemDataType === 4) {
        // 对前3或4列处理
        if (columnIndex < startColumnLength) {
          if (columnIndex === 0) {
            if (row.leaderName && row.pondName) {
              return { rowspan: 1, colspan: 4 };
            } else {
              return { rowspan: 1, colspan: 3 };
            }
          } else {
            return { rowspan: 0, colspan: 0 };
          }
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.itemDataType === 2 || row.itemDataType === 4) {
        return "total-row";
      }
      return "";
    },
    getSummaries(param) {
      const { columns, data } = param;
      console.log(columns, data, "合计");
      return [1, 2];
    },
    // 获取选中时间
    getTime() {
      let startTime = storage.get("start");
      let endTime = storage.get("end");
      if (startTime) {
        this.queryParams.StartDate = startTime;
      } else {
        const start = new Date();
        start.setDate(1);
        start.setMonth(0);
        this.queryParams.StartDate = this.$timeformatDay(start);
      }
      if (endTime) {
        this.queryParams.EndDate = endTime;
      } else {
        this.queryParams.EndDate = this.$timeformatDay(new Date());
      }
    },
    // 存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.queryParams.StartDate);
      } else {
        storage.set("end", this.queryParams.EndDate);
      }
    },
    // 获取周期下拉
    async getBatch() {
      this.batchList = await this.getBatchList();
      this.batchList.unshift("全部");
      // this.batchList = this.batchList;
      this.queryParams.batch = "全部";
    },
    // 判断localstorage 是周期还是时间
    judgeChoose() {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue) {
        this.memoryValue = memoryValue;
      } else {
        this.memoryValue = this.memoryValue;
      }
      if (this.memoryValue == "Batch") {
        // this.start = "";
        // this.end = "";
        this.queryParams.batch = "全部";
      } else if (this.memoryValue == "date") {
        this.queryParams.batch = "";
      }
    },
    //切换时间和周期
    changeBatDateList(e) {
      localStorage.setItem("memoryValue", e);
      console.log(e);
      if (e == "Batch") {
        // this.start = "";
        // this.end = "";
        this.queryParams.batch = "全部";
      } else if (e == "date") {
        this.queryParams.batch = "";
      }
    },
    //周期切换
    batchChange(e) {
      if (e) {
        this.queryParams.batch = e;
        //this.getAllData();
      }
    },
  },
  computed: {
    searchQueryParams() {
      let queryParams = { ...this.queryParams };
      queryParams.dataType = 1;
      queryParams.batch =
        queryParams.batch !== "全部" && this.memoryValue == "Batch"
          ? queryParams.batch
          : "";
      queryParams.StartDate =
        this.memoryValue == "date" ? queryParams.StartDate : "";
      queryParams.EndDate =
        this.memoryValue == "date" ? queryParams.EndDate : "";
      queryParams.BaseId = fishBaseIdForQuery(queryParams.BaseId, this.baseList);
      return queryParams;
    },
  },
};
</script>
<style lang="stylus">
.productionProfitReport {
  height: 100%;

  .content-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .table-container {
      flex: 1;
    }
  }

  .total {
    .el-select__tags {
      top: 65%;
      height: 30px;
      overflow: auto;
    }

    .el-input__suffix {
      top: 6px;
    }

    .is-focus .el-input__suffix {
      top: 0px;
    }
  }

  .scroll-box1 {
    width: 100%;
    // overflow: auto;
    // overflow-x:hidden;
  }

  .table-package {
    width: 100%;
    border-collapse: collapse;
    border: none;
  }

  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);

    .ths, .thsss {
      width: 50px !important;
    }

    >tr th {
      text-align: center;
      height: 36px;
      font-size: 12px;
      line-height: 36px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom: none;
      background-color: #f7f7f7;
    }

    >tr .ths {
      display: table-cell;
      border-bottom: 1px solid rgb(51, 137, 255);
      vertical-align: middle;
    }

    >tr .thss {
      border-bottom: 1px solid rgb(51, 137, 255);
    }

    .trs th {
      width: 50px !important;
      border-bottom: 1px solid rgb(51, 137, 255);
    }
  }

  .table-tbodys {
    :hover {
      background: #c3e3ff;

      td:nth-child(1), td:nth-child(2), td:nth-child(3) {
        background: #fff;
      }
    }

    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border: none;
      background-color: #fff;
    }

    td {
      width: 50px !important;
      border: 1px solid #e0e0e0;
      border-top: none;
      color: #666;
      max-width: 96px;
      word-break: break-all;
      vertical-align: middle;
    }
  }

  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 12px;
      width: 90px !important;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-top: none;
    }

    .row {
      // font-size: 12px;
      // background-color: #fff;
      // font-weight: bold;
      >td {
        // width:50px!important;
        // text-align: center;
        // border: 1px solid #e0e0e0;
        // color: #666;
        // font-weight:bold;
      }
    }
  }

  .hidden {
    display: none;
  }

  .main-table {
    /*
                            ::-webkit-scrollbar {
                              width: 12px;
                              height: 12px;
                            }

                            ::-webkit-scrollbar-track-piece {
                                background-color: rgba(0, 0, 0, 0.2);
                                -webkit-border-radius: 0px;
                            }

                            ::-webkit-scrollbar-thumb:vertical {
                                height: 12px;
                                background-color: rgba(125, 125, 125, 0.7);
                                -webkit-border-radius: 0px;
                            }

                            ::-webkit-scrollbar-thumb:horizontal {
                                width: 12px;
                                background-color: rgba(125, 125, 125, 0.7);
                                -webkit-border-radius: 0px;
                            }


                              .el-table__body-wrapper::-webkit-scrollbar {
                                width: 12px;
                                height: 12px;
                              }
                              .el-scrollbar__wrap::-webkit-scrollbar{
                                width: 12px;
                                height: 12px;
                              }
                            */
  }

  .full-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }
}

.productionProfitReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
}

.productionProfitReport .el-table .el-table__row {
  background: #FFF !important;
}

/* 魔改样式ing */
.productionProfitReport .table-container .el-table .el-table__body tbody td {
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

.productionProfitReport .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
  border-right: 1px solid #e0e0e0;
}

.productionProfitReport .table-container .el-table .el-table__header th .cell {
  line-height: 18px;
  padding: 10px 0px;
}

.productionProfitReport .total-row .cell {
  font-weight: bold;
}

.productionProfitReport .total-row td {
  background-color: #F8F8F8;
}

.productionProfitReport {
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 12px; /* 设置滚动条宽度 */
    height: 12px; /* 设置滚动条高度 */
  }

  .el-table {
    padding-right: 12px;
  }

  .el-table__body-wrapper {
    padding-right: 12px;
  }
}

.productionProfitReport {
  .table-container .el-table .el-table__header th .cell {
    font-size: 12px;
  }

  .table-container .el-table:last-child .cell {
    font-size: 12px;
    line-height: 12px;
    padding: 0;
  }
}
</style>
